import {ContactPersonDataInterface} from "../interfaces/ContactPersonDataInterface";

export const contactPersonFields = (contactPersonData: ContactPersonDataInterface, setContactPersonData: (data: ContactPersonDataInterface) => void, contactPersonFieldsDisabled: boolean) => [
    {
        name: 'company',
        label: 'Bedrijf alternatief contact',
        type: 'text',
        value: contactPersonData.company,
        disabled: contactPersonFieldsDisabled,
        required: true,
        onChange: (data: HTMLInputElement) => setContactPersonData({...contactPersonData, company: data.value})
    },
    {
        name: 'name',
        label: 'Naam alternatief contact',
        type: 'text',
        value: contactPersonData.name,
        disabled: contactPersonFieldsDisabled,
        required: true,
        onChange: (data: HTMLInputElement) => setContactPersonData({...contactPersonData, name: data.value})
    },
    {
        name: 'email',
        label: 'Email alternatief contact',
        type: 'email',
        value: contactPersonData.email,
        disabled: contactPersonFieldsDisabled,
        required: true,
        onChange: (data: HTMLInputElement) => setContactPersonData({...contactPersonData, email: data.value})
    },
    {
        name: 'phone',
        label: 'Telefoonnummer alternatief contact',
        type: 'number',
        value: contactPersonData.phone,
        disabled: contactPersonFieldsDisabled,
        required: true,
        onChange: (data: HTMLInputElement) => setContactPersonData({...contactPersonData, phone: data.value})
    }
]